import React from "react";
import { Popover } from "@material-ui/core";


function Modalbase(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    React.useEffect(()=>{
      setAnchorEl(props.ancla);
    },[])
  return (
    <Popover
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      elevation={0}
      id="popov"
      placement="top-start"
      anchorEl={anchorEl}
      open={Boolean(props.ancla)}
      onClose={() => {
        props.setancla(null);
      }}
    >
      <div
        style={{
          background: "#fff",
          marginTop: 10,
          padding: 15,
          borderRadius: 5,
          borderColor: "rgb(232 232 232)",
          borderStyle: "solid",
          borderWidth: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        { props.contenido }
      </div>
    </Popover>
  );
}

export default Modalbase;
